import {atom} from "recoil";

export const currencyAtom = atom<string[]>({
    key: "currencies",
    default: []
});

export const chargingWayAtom = atom<string[]>({
    key: "chargingWay",
    default: []
});

export const ancillaryTypeAtom = atom<string[]>({
    key: "ancillaryType",
    default: []
});
